import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleRedirect',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

onMounted(async () => {
  await store.dispatch('tempSetToken', route.query.code)
  router.push(localStorage.getItem('returnPath') || '/')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, " Loading Google credentials... "))
}
}

})